<template>
  <div class="card-container">
    <common-top-form
      :selectShow="true"
      selectShowPower="/posratemanage/select"
      :model="formModel"
      :submitService="submitService"
      @success="onSuccess"
      @openAddDialog="openDialog"
      :submitData="submitData"
      addShowPower="/posratemanage/add"
      :goback="true"
    >
      <el-form-item label="交易类型">
        <el-select v-model="formModel.transType" clearable>
          <el-option
            v-for="item in transType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否有代付费">
        <el-select v-model="formModel.havePay" clearable>
          <el-option
            v-for="item in havePay"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级名称">
        <el-select v-model="formModel.memLevelId" clearable>
          <el-option
            v-for="item in Mem"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getList"
      :isShow="false"
    >
   
      <el-table-column
        prop="transType"
        label="交易类型"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterTableTransType"
      ></el-table-column>
      <el-table-column
        prop="havePay"
        label="是否有代付费"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.havePay == 0"
            style="color: red; font-size: 20px"
            class="el-icon-circle-close"
          />
          <i
            v-else
            style="color: green; font-size: 20px"
            class="el-icon-circle-check"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="memLevelName"
        label="等级名称"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="fee"
        label="费率"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="tatFee"
        label="底价"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="180"
        v-if="hasPerm('/posratemanage/update')"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="openDialog(scope.row)"
            v-if="hasPerm('/posratemanage/update')"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
    >
      <el-form-item label="父页费率" label-width="120px">
        <span style="color: red; font-size: 24px">
          {{ posratemanage.fee }}</span
        >
      </el-form-item>
    
      <el-form-item label="等级名称" prop="memLevelId" label-width="120px">
        <el-select v-model="dialogModel.memLevelId" style="width: 203.3px">
          <el-option
            v-for="item in Mem"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易类型" prop="transType" label-width="120px">
        <el-select
          :disabled="this.itemId == '' ? false : true"
          v-model="dialogModel.transType"
          style="width: 203.3px"
        >
          <el-option
            v-for="item in transType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否有代付费" prop="havePay" label-width="120px">
        <el-radio-group v-model="dialogModel.havePay">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="费率" prop="fee" label-width="120px">
        <div class="flex-row vertical-center flow-justify">
          <el-input-number
            style="width: 203.3px"
            v-model="dialogModel.fee"
            :controls="false"
            :precision="6"
            :step="0.1"
            controls-position="right"
            :min="0"
            placeholder="请输入"
          ></el-input-number>
        </div>
      </el-form-item>
      <div style="margin-top: 40px">
        <el-form-item label="底价" prop="tatFee" label-width="120px">
          <div class="flex-row vertical-center flow-justify">
            <el-input-number
              style="width: 203.3px"
              v-model="dialogModel.tatFee"
              :controls="false"
              :precision="6"
              :step="0.1"
              controls-position="right"
              :min="0"
              placeholder="请输入"
            ></el-input-number>
          </div>
        </el-form-item>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "@/view/dialog/FormDialog";

import PosService from "service/PosService";
import Merchant from "@/service/Merchant";
import OrganService from "service/OrganService";
import TransactionType from "service/constant/TransactionType";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "posratemanage",
  data() {
    return {
      posratemanage: {},
      formModel: {
        transType: "",
        havePay: "",
        memLevelId: "",
      },
      submitService: Merchant.posratemanageList,
      tableData: [],
      hardwareTypeStatus: [],
      transType: [],
      havePay: [
        { id: "1", name: "是" },
        { id: "0", name: "否" },
      ],
      Mem: [],
      itemId: "",
      dialogModel: {
      
        memLevelId: "",
        transType: "",
        memLevelName: "",
        fee: undefined,
        tatFee: undefined,
        havePay: "0",
      },
      dialogRules: {
       
        memLevelId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        tatFee: [
          {
            required: true,
            message: "请输入",
          },
        ],
        transType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        fee: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                !value ||
                value > 1 ||
                value < 0 ||
                value < this.posratemanage.fee
              ) {
                callback(
                  new Error("费率不能大于1且不能小于0且不能小于父页费率")
                );
              } else {
                callback();
              }
            },
          },
        ],
      },
      page: {},
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  created() {
    this.posratemanage = JSON.parse(this.$route.params.item);
  },
  mounted() {
    this.formModel = {
      transType: "",
      havePay: "",
      memLevelId: "",
    };
    this.getTypeNames("transType", (res) => {
      this.transType = [...this.transType, ...res];
    });
    this.gethardwareTypeStatus();
    this.getMem();
    this.getList();
    this.getMem();
    this.page = this.$refs.commonTable.page;
  },
  computed: {
    submitData() {
      const params = {
        id: this.posratemanage.id,
        transType: this.formModel.transType,
        havePay: this.formModel.havePay,
        memLevelId: this.formModel.memLevelId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    dialogData() {
      const params = {
      
        memLevelId: this.dialogModel.memLevelId,
        transType: this.dialogModel.transType,
        memLevelName: this.dialogModel.memLevelName,
        fee: this.dialogModel.fee,
        tatFee: this.dialogModel.tatFee,
        havePay: this.dialogModel.havePay,
        pid: this.posratemanage.id,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? Merchant.posratemanageEdit
        : Merchant.posratemanageInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    "dialogModel.memLevelId"(val, oldVal) {
      if (val) {
        this.dialogModel.memLevelName = this.Mem.find(
          (item) => item.id == val
        ).levelName;
      }
    },
  },
  methods: {
    openDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result;

            this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
          });
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
  
        memLevelId: "",
        transType: "",
        memLevelName: "",
        fee: undefined,
        tatFee: undefined,
        havePay: "0",
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    gethardwareTypeStatus() {
      //硬件产品类型
      this.doLoad(
        PosService.posYingJianType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareTypeStatus = [
              ...this.hardwareTypeStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    getMem() {
      //代理商等级
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.Mem = res.contents.rows;
          });
        },
        "信息获取失败"
      );
    },
    formatterTableTransType(row, column, cellValue, index) {
      let value = "";
      this.transType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });

      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
.type-title {
  font-size: 20px;
  color: #000;
}

.type-msg {
  font-size: 20px;
  color: #aaaaaa;
  margin-left: 10px;
}

.box-card {
  margin-bottom: 30px;
}

.unit {
  margin-left: 10px;
  color: #aaaaaa;
}

.levelList {
  display: flex;
  flex-wrap: wrap;
}

.type-box {
  margin-bottom: 22px;
}

.people-check {
  text-align: right;
  padding-right: 12px;
  margin-bottom: 20px;
  padding-left: 90px;
}

.up-people-list {
  padding-left: 90px;
}

.upPeople-desc {
  margin-bottom: 20px;
  font-weight: bold;
}

.pad-right {
  padding-right: 70px;
}

.pad-left {
  padding-left: 90px;
}

.mar_bot {
  margin-bottom: 20px;
}

.notice-text {
  color: #aaaaaa;
  margin-top: -10px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AAmerchantMange.vue